import React, { useEffect, useState } from 'react';
import DockVerticalDerecha from '../estructura/DockVerticalDerecha';
import { toast } from 'react-toastify';
import instanciaAxios from '../../miscelaneo/instanciaAxios';
import PlantillaModal from '../util/PlantillaModal';
import TablaListaPrecio from '../util/tablas/TablaListaPrecio';   // ⇦ crea una tabla parecida a TablaCategoria

function MantenimientoListaPrecio() {
  const [formData, setFormData] = useState({});
  const [estados, setEstados] = useState([
  {
   label: 'Activo',
   value: 1 
  },
  {
    label: 'Inactivo',
    value: 2
  }
]);
  const [cargando, setCargando] = useState(true);

  const [modo, setModo] = useState('creacion');     
  const [editable, setEditable] = useState(true);   // controla <input disabled>
  const [listaSeleccionada, setListaSeleccionada] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  // Deshabilita el botón "Guardar" mientras se espera la respuesta del backend
  // (evita que un doble clic duplique la lista de precio).
  const [guardando, setGuardando] = useState(false);

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value
    }));
  };

 

  useEffect(() => {
  setEditable(modo !== 'ver');

  setListaSeleccionada(null);

  if (modo === 'ver') {
    toast.info('Modo solo observación');
  }
  if (modo === 'edicion') {
    toast.info('Modo edición');
  }
  if (modo === 'creacion') {
    toast.info('Modo creación');
  }
}, [modo]);


  /* ---------- definición de campos ---------- */
  const campos = [
    { id: 'descripcion', type: 'text', label: '*Descripción', placeholder: 'Descripción', seccion: 'Información de lista de precio' },
    {
      id: 'id_estado',
      type: 'select',
      label: 'Estado',
      opciones: estados.map(e => ({ label: e.label, value: e.value })),
      placeholder: 'Estado',
      seccion: 'Información de lista de precio'
    }
  ];
  /* agrupar por sección */
  const camposPorSeccion = campos.reduce((acc, c) => {
    (acc[c.seccion] = acc[c.seccion] || []).push(c);
    return acc;
  }, {});

  /* ---------- guardar / crear / editar ---------- */
  const submitListaPrecio = async () => {
    if (guardando) return;
    /* validaciones básicas */
    if (!formData.descripcion) {
      toast.error('La descripción es obligatoria');
      return;
    }
    if (!formData.id_estado) {
      toast.error('Debe seleccionar un estado');
      return;
    }

    try {
      let idLista = formData.id_lista_precio;
      const payload = { ...formData };

      if (modo === 'ver') {
        toast.info('Modo solo observación. No se puede guardar.');
        return;
      }

      setGuardando(true);

      if (modo === 'creacion') {
        const res = await instanciaAxios.post('/miscelaneo/lista_precio', payload);
        idLista = res.data.id_lista_precio;
        setFormData(prev => ({ ...prev, id_lista_precio: idLista }));
        toast.success('Lista de precio registrada');
      }

      if (modo === 'edicion') {
        await instanciaAxios.put('/miscelaneo/lista_precio', payload);
        toast.success('Lista de precio editada');
      }

      setModo('ver');
    } catch (err) {
      console.error(err);
      toast.error('Error al guardar la lista de precio');
    } finally {
      setGuardando(false);
    }
  };

  /* ---------- handlers de botones ---------- */
  const handleBuscar = () => {
    setMostrarModal(true);
    setModo('ver');
  };

  const handleSeleccionar = (lista) => {
    setListaSeleccionada(lista);
    setFormData(lista);
    setMostrarModal(false);
    console.log(lista)
  };

  const handleEditar = () => {
    setMostrarModal(true);
    setModo('edicion');
  };

  const handleCrear = () => {
    setModo('creacion');
    setFormData({});
  };

  /* ---------- render ---------- */
  return (
    <div className="bg-gray-200 min-h-screen">
      <div className="flex justify-center py-10">
        <div className="bg-gray-100 bg-opacity-90 rounded-xl border p-12 w-full max-w-7xl mx-10">
          <form className="flex flex-col gap-8">
            <header className="space-y-1">
              <h1 className="font-cascadia font-bold text-2xl">Lista de precio</h1>
              <p className="text-gray-500">Gestione las listas de precio.</p>
            </header>

            {Object.entries(camposPorSeccion).map(([titulo, campos]) => (
              <section key={titulo}>
                <h2 className="text-lg font-semibold mb-4">{titulo}</h2>
                <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(230px,_1fr))]">
                  {campos.map(c => (
                    <div key={c.id} className="flex flex-col">
                      <label htmlFor={c.id} className="text-sm font-medium text-gray-600 mb-1">{c.label}</label>
                      {c.type === 'select' ? (
                        <select
                          id={c.id}
                          value={formData[c.id] || ''}
                          onChange={handleChange}
                          disabled={!editable}
                           className="w-full p-2 rounded-xl text-gray-700 border border-gray-400">
                          <option value="">Seleccione</option>
                          {c.opciones.map(o => (
                            <option key={o.value} value={o.value}>{o.label}</option>
                          ))}
                        </select>
                      ) : (
                        <input
                          id={c.id}
                          type={c.type}
                          placeholder={c.placeholder}
                          value={formData[c.id] || ''}
                          onChange={handleChange}
                          disabled={!editable}
                          className="w-full p-2 rounded-xl text-gray-700 border border-gray-400" />
                      )}
                    </div>
                  ))}
                </div>
              </section>
            ))}
          </form>

          {/* botones flotantes */}
          <DockVerticalDerecha
            handleBotonGuardar={submitListaPrecio}
            handleBotonCrear={handleCrear}
            handleBotonBuscar={handleBuscar}
            handleBotonEditar={handleEditar}
            guardando={guardando}
          />

          {/* modal para buscar / seleccionar lista de precio */}
          <PlantillaModal mostrar={mostrarModal} onClose={() => setMostrarModal(false)}>
            <TablaListaPrecio
              descripcion="Seleccione la lista de precio para ver o editar."
              setListaSeleccionada={handleSeleccionar}
            />
          </PlantillaModal>
        </div>
      </div>
    </div>
  );
}

export default MantenimientoListaPrecio;
